import React from 'react';
import { connect } from 'react-redux';
import { Form } from 'antd';
import UploadPhoto from '../../../../../../common/components/UploadPhoto/UploadPhoto';
import {
  UPLOAD_DRIVER_LICENSE_PHOTO_BACK,
  UPLOAD_DRIVER_LICENSE_PHOTO_FRONT,
} from '../../../../api/constants';

const DriverLicensePhoto = ({ isEditable, form, profileId }) => {
  // validateField
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
  const employeeId = getFieldValue('profileId');

  return (
    <div className="b-form-fields">
      <div className="b-form-fields__item">
        <Form.Item
          label={
            <span className="label-multiline">
              Фотография лицевой стороны водительского удостоверения
            </span>
          }
        >
          {getFieldDecorator('driverLicensePhotoFront', {
            valuePropName: 'image_url',
          })(
            <UploadPhoto
              disabled={!isEditable}
              name={'driverLicensePhotoFront'}
              data={{ profile_id: profileId, employee_id: employeeId }}
              action={
                employeeId && employeeId > 0
                  ? UPLOAD_DRIVER_LICENSE_PHOTO_FRONT
                  : null
              }
              update={
                employeeId && employeeId > 0
                  ? null
                  : file => setFieldsValue({ driverLicensePhotoFront: file })
              }
            />
          )}
        </Form.Item>
      </div>
      <div className="b-form-fields__item">
        <Form.Item
          label={
            <span className="label-multiline">
              Фотография оборотной стороны водительского удостоверения
            </span>
          }
        >
          {getFieldDecorator('driverLicensePhotoBack', {
            valuePropName: 'image_url',
          })(
            <UploadPhoto
              disabled={!isEditable}
              name={'driverLicensePhotoBack'}
              data={{ profile_id: profileId, employee_id: employeeId }}
              action={
                employeeId && employeeId > 0
                  ? UPLOAD_DRIVER_LICENSE_PHOTO_BACK
                  : null
              }
              update={
                employeeId && employeeId > 0
                  ? null
                  : file => setFieldsValue({ driverLicensePhotoBack: file })
              }
            />
          )}
        </Form.Item>
      </div>
    </div>
  );
};

export default connect(state => ({
  profileId: state.Authorization.activeProfile.profileId,
}))(DriverLicensePhoto);
